/* eslint-disable no-unused-vars */
import classNames from 'classnames';
import { useState } from 'react';
import request from '../../utils/APIHelper/request';
import {
  controllers,
  requestTypes,
  responseTypes,
} from '../../constants/enums/API';
import { toast } from 'react-toastify';
import loadingGif from '../../assets/Other/loading.gif';
import AgentAddingWindow from './AgentAddingWindow';
import Swal from 'sweetalert2';
import { currentUser } from '../../utils/Auth/auth';
import { cleanObject } from '../../utils/cleanObject';

const defaultAgent = {
  id: null,
  agentCode: null,
  agentGroup: null,
  suspension: null,
  toBePrinted: null,
  branchId: Number.parseInt(currentUser?.baseBranch) || 1,
  agentName: null,
  additionalName: null,
  contactName: null,
  wholesellerCode: null,
  address: null,
  unit: null,
  city: null,
  provinceState: null,
  country: currentUser?.baseBranch === '1' ? 'CAN' : 'USA',
  pCodeZip: null,
  phone1: null,
  phone2: null,
  fax: null,
  selPhone: null,
  freePhone: null,
  website: null,
  email: null,
  currency: currentUser?.baseBranch === '1' ? 'CAD' : 'USD',
  status: 'A',
  salutation: null,
  language: 'E',
  webSearch: null,
  catalog: null,
  megaPolice: null,
  rank: null,
  servList: 'P.',
  busStatus: null,
  workHours: null,
  pickup: null,
  latitude: null,
  longitude: null,
  useCarrier: null,
  master: null,
  carrierCode: null,
  zones: null,
};

const AddAgentByEmailModal = ({ addingType }) => {
  const [email, setEmail] = useState('');
  const [searchLoading, setSearchLoading] = useState(false);

  const [createLoading, setCreateLoading] = useState(false);

  const [data, setData] = useState(defaultAgent);
  const [extension, setExtension] = useState(null);

  const getAgentData = async () => {
    const result = await request({
      url: `${controllers.agent}getAgentPrecreationModel`,
      type: requestTypes.post,
      params: {
        email,
      },
      setLoading: setSearchLoading,
    });
    if (result.code !== responseTypes.success) {
      toast.error(result.message);
    } else {
      setData(result.result);
    }
  };

  const createNewAgent = async () => {
    const result = await request({
      url: `${controllers.agent}createAnAgent`,
      type: requestTypes.post,
      body: { agent: data, ext: cleanObject(extension) },
      setLoading: setCreateLoading,
    });
    if (result.code !== responseTypes.success) {
      toast.error(result.message);
    } else {
      toast.success(result.message);
      window.location.reload();
      Swal.close();
    }
  };

  return (
    <>
      {data === defaultAgent && addingType === 'email' ? (
        <div className="text-lg">
          <div>Enter email address of an account:</div>
          <input
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="border-b border-blue-800 focus:border-blue-400 text-blue-900 focus:outline-none px-2 py-1 mt-2"
            placeholder="example@meest.com..."
          />
          <br />
          <div className="my-5">
            {' '}
            {searchLoading ? (
              <img className="w-5 h-5 mx-auto my-5" src={loadingGif} />
            ) : (
              <div
                onClick={() => {
                  if (email.length > 0) getAgentData();
                }}
                className={classNames(
                  'bg-blue-900 text-white px-4 inline-block rounded-full hover:transition-all hover:duration-30 cursor-pointer',
                  email.length < 1 && '!bg-gray-400 !cursor-auto',
                )}
              >
                Search
              </div>
            )}
          </div>
          <div className="p-4">
            <div
              onClick={() => Swal.close()}
              className="float-right bg-gray-300 text-gray-700 inline-block px-3 py-1 rounded-[0.2rem] cursor-pointer"
            >
              Close
            </div>
          </div>
        </div>
      ) : (
        <div>
          <div>
            <AgentAddingWindow
              data={data}
              setData={setData}
              extension={extension}
              setExtension={setExtension}
              enableExtension={true}
            />
          </div>
          <div className="p-4">
            {createLoading ? (
              <img
                className="w-5 h-5 mx-auto float-left my-2 ml-3"
                src={loadingGif}
              />
            ) : (
              <div
                onClick={createNewAgent}
                className="float-left bg-blue-900 text-white inline-block px-3 py-2 rounded-[0.2rem] cursor-pointer"
              >
                Create
              </div>
            )}

            <div
              onClick={() => Swal.close()}
              className="float-right bg-gray-300 text-gray-700 inline-block px-3 py-2 rounded-[0.2rem] cursor-pointer"
            >
              Close
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AddAgentByEmailModal;
